<template>
  <div class="row">
    <div class="col s12">
      <div class="card">
        <div class="card-content">
          <p>{{message}}</p>
        </div>
        <div class="card-action">
          <router-link :to="linkPath">{{linkLabel}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    message : String,
    linkPath : String,
    linkLabel : String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
